export const HISTORY_QUERY_KEY = "history";
export const HISTORY_QUERY_VALUE = "true";

export function hasHistoryQuery(query: Record<string, unknown> | undefined | null): boolean {
  if (!query) return false;
  const value = query[HISTORY_QUERY_KEY];
  if (Array.isArray(value)) {
    return value.some((item) => item === HISTORY_QUERY_VALUE);
  }
  return value === HISTORY_QUERY_VALUE;
}

export function omitHistoryQuery(query: object): Record<string, unknown> {
  const next = { ...(query as Record<string, unknown>) };
  delete next[HISTORY_QUERY_KEY];
  return next;
}

export function shouldRedirectEmptyListToCreate(itemId?: string | null): boolean {
  return !itemId;
}

/** Desktop の全体プロット ID（`overall-plot-{novelId}`）も、Web の全体プロット（plotId なし / data-id `default`）として扱う。 */
export function isOverallPlotRouteId(plotId?: string | null): boolean {
  if (!plotId) return true;
  return plotId.startsWith("overall-plot-");
}

export type ListDeepLinkResult = { action: "keep" } | { action: "create" } | { action: "navigate"; id: string };

export function resolveListDeepLink(input: {
  requestedId?: string | null;
  recentId?: string | null;
  itemIds: string[];
}): ListDeepLinkResult {
  const requestedId = input.requestedId || undefined;
  const { recentId, itemIds } = input;

  if (requestedId) {
    return { action: "keep" };
  }
  if (itemIds.length === 0) {
    return { action: "create" };
  }
  if (recentId && itemIds.includes(recentId)) {
    return { action: "navigate", id: recentId };
  }
  return { action: "navigate", id: itemIds[0] };
}
